import { Directive, Input } from '@angular/core';

@Directive({
  selector: 'img[default]',
  host: {
    '(error)': 'updateUrl()',
    '[src]': 'src',
  },
})
export class DefaultImage {
  @Input() src: string;
  @Input() default: string;

  constructor() {}

  updateUrl() {
    console.log(this.src);
    this.src = this.default;
  }
}
